<template>
  <div v-for="node in settingPanels[nodeType]" :key="node.key" class="my-1 flex flex-col">
    <Field
      :field="node"
      :value="getValue(node.key)"
      :module="module"
      @change="handleChange(node.key, $event, arguments[1])"></Field>
  </div>
</template>

<script setup>
import { settingPanels } from '@/constants/settingPanels';
import Field from './Field.vue';

const props = defineProps({
  nodeType: {
    type: String,
    default: null,
  },
  module: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['update']);

// const getValue = (key) => {
//   if (!props.module?.data) return undefined
//   return props.module.data[key]
// }
const getValue = (key) => {
  if (!props.module) return undefined;
  if (props.module[key] !== undefined) {
    return props.module[key]; // root fields
  }
  if (!props.module?.data) return undefined;
  return props.module.data[key];
};

const handleChange = (key, value, isRoot = false) => {
  emit('update', { key, value, isRoot });
};
</script>
